import { apiClient } from '@/utils/api-client';

// Nested under hubAppCopy.portalCopy in Contentful (same `portalCopy` Object
// the user portal uses for profile, subscription, etc.). Powers the admin
// Delete User confirmation modal.
export interface UserDeletionCopy {
  ownedProjectsLabel?: string;
  reassignmentSummary?: string;
  supportLinkText?: string;
  supportLinkUrl?: string;
}

export interface HubPortalCopy {
  userDeletion?: UserDeletionCopy;
  [key: string]: unknown;
}

// hubAppCopy entry (subset). See contentful/snapshot/hubAppCopy.js — includes
// portalCopy, searchCopy, summaryCopy as localized Objects.
export interface HubAppCopy {
  portalCopy?: HubPortalCopy;
  [key: string]: unknown;
}

interface AppCopyResponse {
  data: HubAppCopy;
  status: string;
}

export const contentfulService = {
  /**
   * Hub app copy (`hubAppCopy` content type). Uses the same endpoint as global
   * app copy with `type=hub` — no extra API work.
   */
  async getHubAppCopy(locale?: string): Promise<HubAppCopy> {
    const params: Record<string, string> = { type: 'hub' };
    if (locale) params.locale = locale;
    const response = await apiClient.get<AppCopyResponse>(
      '/api/contentful/app-copy',
      params,
    );
    return response.data;
  },
};
